module.exports = __webpack_public_path__ + "img/item4-1.ddfe9b6b.jpg";